export const GLUE_TESTNET_PERMIT2_ADDRESS =
  "0xc9d81b27a776555f78ee6aba8b7a522fc87bbcbb";
export const GLUE_DEVNET_PERMIT2_ADDRESS =
  "0xBB48E2d33A397094DE6587D649A251FBBB6658dA";
export const GLUE_MAINNET_PERMIT2_ADDRESS =
  "0xb615b6dcE9d01C7C512234387Cbb2249B07C193b";
